module.exports = __webpack_public_path__ + "static/media/female.f0cc30e4.gif";